import React, { useEffect, useState } from "react";
import "./Sedes.css";
import { apiGet } from '../../utils/api';
import { configShop } from '../../states/configShop';
import { FaMapMarkerAlt, FaChevronRight } from "react-icons/fa";
import { useLocation } from "react-router-dom";

export const Sedes = () => {
    const location = useLocation();
    const url = window.location.origin + location.pathname;
    const { dataConfig } = configShop();

    const [imagenHead, setImagenHead] = useState(null);
    const [branches, setBranches] = useState([]);
    const [loading, setLoading] = useState(true);

    const obtenerListaTiendas = async () => {
        try {
            const res = await apiGet('/app');
            if (res.success === "success") {
                setImagenHead(res.properties.img_home);
                localStorage.removeItem("infoProductoSeleccionado");
                localStorage.removeItem("uuidShop");
                localStorage.removeItem("typeSend");
                localStorage.setItem("colorBoton", res.properties.color_botton);
                localStorage.setItem("colorHover", res.properties.color_hover);
                setBranches(res.data?.branch || []);
            }
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        obtenerListaTiendas();
    }, []);

    const brand = dataConfig?.color_botton;
    const brandText = dataConfig?.color_button_text;

    const sedes = dataConfig?.page_sedes;
    const colorSubtitle = sedes?.color_subtitle ?? dataConfig?.page_menu?.button?.color_text;
    const colorSubtitleDescription = sedes?.color_subtitle_description ?? dataConfig?.page_menu?.button?.color_text;
    const colorSectionLabel = sedes?.color_section_label ?? dataConfig?.page_menu?.color_social_networks;
    const cardBackground = sedes?.card?.background ?? dataConfig?.page_menu?.button?.color;
    const cardIconBackground = sedes?.card?.icon_background ?? dataConfig?.page_menu?.button?.color_text;
    const cardIconColor = sedes?.card?.icon_color ?? dataConfig?.page_menu?.button?.color;
    const cardColorName = sedes?.card?.color_name ?? dataConfig?.page_menu?.button?.color_text;
    const cardColorAddress = sedes?.card?.color_address ?? dataConfig?.page_menu?.button?.color_text;
    const cardArrowColor = sedes?.card?.arrow_color;

    return (
        <div className="sd-page">

            {/* ── Blurred background ── */}
            <div
                className="sd-bg"
                style={{
                    backgroundImage: `url(${sedes?.background_image || imagenHead})`,
                    filter: `blur(18px) brightness(${sedes?.overlay_brightness ?? 0.6}) saturate(1.2)`
                }}
            />
            <div className="sd-bg-tint" />

            {/* ── Decorative glow ── */}
            <div className="sd-glow sd-glow-a" style={{ background: cardIconBackground }} />
            <div className="sd-glow sd-glow-b" style={{ background: cardIconColor }} />

            {/* ── Content ── */}
            <div className="sd-content">

                {/* Logo */}
                {dataConfig?.company_logo && (
                    <div className="sd-logo-wrap">
                        <img className="sd-logo" src={dataConfig.company_logo} alt={dataConfig?.company_name || "logo"} />
                    </div>
                )}

                {/* Hero */}
                <div className="sd-hero">
                    <h1 className="sd-hero-title color-text" style={{ "--btn-font-color": colorSubtitle }}>{dataConfig?.page_home?.subtitle}</h1>
                    {dataConfig?.description_home && (
                        <p className="sd-hero-desc color-text" style={{ "--btn-font-color": colorSubtitleDescription }}>{dataConfig?.page_home?.subtitle_description}</p>
                    )}
                    {!loading && branches.length > 0 && (
                        <span
                            className="sd-badge color-text"
                            style={{ "--btn-font-color": colorSectionLabel, borderColor: `color-mix(in srgb, ${colorSectionLabel || "#fff"} 35%, transparent)` }}
                        >
                            <FaMapMarkerAlt size={11} /> {branches.length} {branches.length === 1 ? "sede disponible" : "sedes disponibles"}
                        </span>
                    )}
                </div>

                {/* Branch list */}
                <div className="sd-branches">
                    {!loading && branches.length > 0 && (
                        <p className="sd-section-label color-text" style={{ "--btn-font-color": colorSectionLabel }} >Nuestras sedes</p>
                    )}

                    {loading && (
                        <>
                            {[0, 1, 2].map((i) => (
                                <div key={i} className="sd-card sd-card-skeleton" style={{ animationDelay: `${i * 0.08}s` }}>
                                    <div className="sd-skel sd-skel-icon" />
                                    <div className="sd-card-body">
                                        <div className="sd-skel sd-skel-line sd-skel-line-name" />
                                        <div className="sd-skel sd-skel-line sd-skel-line-addr" />
                                    </div>
                                </div>
                            ))}
                        </>
                    )}

                    {!loading && branches.length === 0 && (
                        <div className="sd-empty color-text" style={{ "--btn-font-color": colorSubtitleDescription }}>
                            <FaMapMarkerAlt size={26} />
                            <p>Aún no hay sedes registradas</p>
                        </div>
                    )}

                    {!loading && branches.map((item, i) => (
                        <a
                            key={i}
                            className="sd-card sd-card-in"
                            href={item?.point}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ "--brand": cardIconBackground, 'backgroundColor': cardBackground, animationDelay: `${i * 0.07}s` }}
                        >
                            {/* Icon */}
                            <div className="sd-icon" style={{ background: `linear-gradient(145deg, ${cardIconBackground}, color-mix(in srgb, ${cardIconBackground} 65%, black))` }}>
                                <FaMapMarkerAlt size={20} color={cardIconColor} />
                            </div>

                            {/* Info */}
                            <div className="sd-card-body">
                                <p className="sd-card-name color-text" style={{ "--btn-font-color": cardColorName }}>{item.name}</p>
                                <p className="sd-card-address color-text" style={{ "--btn-font-color": cardColorAddress }}>
                                    {[item.address, item.city].filter(Boolean).join(", ")}
                                </p>
                            </div>

                            {/* Arrow */}
                            <div className="sd-card-arrow" style={cardArrowColor ? { color: cardArrowColor, borderColor: cardArrowColor } : undefined}>
                                <FaChevronRight size={14} />
                            </div>
                        </a>
                    ))}
                </div>
            </div>

            {/* ── Footer ── */}
            <footer className="sd-footer">
                <a
                    href="https://sealky.co/"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {new Date().getFullYear()} Hecho con ❤️ y mucho sabor · sealky.co
                </a>
            </footer>
        </div>
    );
};
